/**
 * CAAA1110：ログイン前情報取得API（入力項目）
 */
export default class CAAA1110RequestModel {
  id: number
}
